// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4458":"perps","4609":"bridge","7483":"orderly","7667":"spot"}[chunkId] + "." + {"4458":"c6cad621","4609":"4ef57a16","7483":"c6cad621","7667":"c6cad621"}[chunkId] + ".chunk.css";
};